<template lang="pug">
  .py-2
    .show-checklist(v-if='checklist')
      .h4 Checklist
      .pb-2.grupo(v-for='grupo in checklist' :key='grupo.id')
        .divider.text-center(:data-content='grupo.titulo')
        .perguntas(v-for='pergunta in grupo.perguntas' :key='pergunta.id')
          show-pergunta(:pergunta='pergunta')
    .empty.my-2(v-else)
      .empty-icon
        i.fa.fa-search.fa-2x
      .empty-title.h5 Checklist vazio
</template>

<script>
import ShowPergunta from "./Pergunta"

export default {
  props: { checklist: { type: [Object, Array], default: null } },
  components: { ShowPergunta },
}
</script>

<style lang="stylus">
.show-checklist
  .grupo
    padding-left 1rem
    .perguntas
      .pergunta
        .titulo
          font-size .8rem
        .resposta
          font-size .7rem
          padding-left 1rem
          padding-bottom 1rem
        .fotos
          padding-left 1rem
          padding-bottom 1rem
          .foto
            max-width 150px
</style>
